import { app } from '../../bootstrap/core';
import { authConfig } from './auth.config';
import { authResponseObserver } from './authResponse.factory';
import { AuthService } from './auth.service';
import { requiresAuth } from './ui/requiresAuth.directive';

app.config(authConfig);
app.factory('authResponseObserver', authResponseObserver);
app.service('authService', AuthService);
app.directive('requiresAuth', requiresAuth);
